import { AgentVersionHistoryPanel } from '@/components/projects'
import { useAgentDetailContext } from '@/hooks'

export function AgentVersionHistoryPage() {
  const { projectId, agent, editorYaml } = useAgentDetailContext()

  return (
    <div data-testid="agent-version-history-section">
      <AgentVersionHistoryPanel projectId={projectId} agent={agent} currentEditorYaml={editorYaml} />
    </div>
  )
}
